<template>
  <div
    class="tw-flex tw-leading-[100%] tw-flex-col tw-justify-center tw-items-start tw-rounded-[6px] tw-pt-[25px] question-body"
  >
    <div
      class="tw-flex tw-items-center tw-gap-[10px] tw-pb-[10px] tw-px-[25px]"
    >
      <span
        class="tw-text-[#211F58] tw-text-[15px] tw-font-medium tw-leading-[145%]"
        >{{ title }}</span
      >
    </div>
    <div class="tw-px-[25px] tw-pb-[25px] description-body">
      <span class="tw-text-[13px] tw-font-normal tw-text-[#878787]">{{
        description
      }}</span>
      <span
        v-if="isHaveSubDecription"
        class="tw-text-[13px] tw-font-medium tw-leading-[100%] tw-text-[#387DFF] tw-pl-[4px] tw-cursor-pointer hover:tw-opacity-80"
        @click="openModalMoreInfor"
        >{{
          getComponentUiText(
            "app-menu-submenu-home-setup-wizard-domains-page-sub-title-2",
          )
        }}</span
      >
    </div>
    <QuestionPage
      :title="titleQuestion"
      :border-select="true"
      :question-type="questionType"
      :dropdown-data="dropdownData"
      :is-true="isDomainName"
      @update:answer="handleAnswer"
    />
    <div v-if="currentValue" class="tw-px-[25px] tw-pb-[25px]">
      <div
        v-if="
          statusInPage.statusPage === statusPage.Error &&
          statusInPage.errorMessage
        "
        class="tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[12px] tw-mb-[13px] tw-rounded-[6px] tw-gap-[10px]"
      >
        <WarningIcon color="#F7553C" />
        <p
          class="tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]"
        >
          {{
            getComponentUiText(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: statusInPage.errorMessage
                  ? ensurePeriod(statusInPage.errorMessage)
                  : "",
              },
            )
          }}
        </p>
      </div>
      <p class="tw-mb-[25px] tw-pt-[12px] tw-leading-[100%]">
        <span class="tw-text-[#231F20] tw-text-[14px] tw-font-medium">{{
          getComponentUiText("app-menu-submenu-home-setup-wizard-sites-note-1")
        }}</span>
      </p>
      <div v-for="(item, index) in domains" :key="`${index}`">
        <ListDomain
          ref="listDomainRef"
          :item="item"
          :current-index="index"
          :status-in-page="statusInPage"
          :data="{ item, index }"
          @change-status-add-domain="
            emits('onUpdate', $event), checkAllValidations
          "
        />
      </div>
      <ButtonAddAnother @click="addAnother" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import QuestionPage from "./questionPage.vue";
import { WIZARD_STATE_NAME, wizardQuestionAnswerType } from "@/utils/constants";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME, statusPage } from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import ButtonAddAnother from "./buttonAddAnother.vue";
import store from "@/store";
import { computed } from "vue";
import ListDomain from "./listDomain.vue";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
import WarningIcon from "../svgs/warningIcon.vue";

const currentOrg = computed(() => store.state.Org.currentOrg);
const emits = defineEmits(["onUpdate", "check:answer", "update:answer"]);
const currentValue = ref(0);
const listDomainRef: any = ref([]);

const domains = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.domains[0]?.values) {
    return setupWizard.questions[currentOrg.value.id].domains[0].values.map(
      (el) => ({
        ...el,
        showAccordion: false,
      }),
    );
  } else {
    return [];
  }
});

const isDomainName = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.domains[0]?.values) {
    const isDomainName = setupWizard.questions[
      currentOrg.value.id
    ].domains[0].values.some((item) => item.id && !item.isArchived);
    return isDomainName ? 1 : "";
  } else {
    return "";
  }
});

const route = useRoute();

onMounted(() => {
  const queryValue = route.query?.type;
  if (queryValue === WIZARD_STATE_NAME.DOMAINS) {
    addAnother();
    setTimeout(() => {
      document
        .getElementById(`input-domain-${domains.value.length - 1}`)
        ?.focus();
    }, 500);
  }
});

const addAnother = () => {
  const objAdd = {
    id: "",
    domainName: "",
    domainRegistrarId: null,
    domainRegistrar: null,
    startDate: new Date(),
    description: null,
    notes: null,
    endDate: null,
    showAccordion: false,
    isEdit: true,
    isArchived: false,
  };
  domains.value.forEach((item) => (item.showAccordion = false));
  store.commit("SetupWizard/SET_DOMAIN_NAME_PUSH", {
    objAdd,
    currentOrg: currentOrg.value.id,
  });
  // emits("changeStatusAddDomain", true);
};

const props = defineProps({
  titleQuestion: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  questionType: {
    type: String,
    default: wizardQuestionAnswerType.radio,
  },
  dropdownData: {
    type: Array,
    default: () => [],
  },
  isHaveSubDecription: {
    type: Boolean,
    default: false,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});

watch(props.statusInPage, (value) => {
  if (
    (value.statusPage === statusPage.CallApi ||
      value.statusPage === statusPage.Error) &&
    (props.statusInPage.dataError.length > 1 ||
      (props.statusInPage.dataError.length === 1 &&
        !props.statusInPage.dataError[0].endDate))
  ) {
    domains.value.forEach((item, index) => {
      store.commit("SetupWizard/SET_DOMAIN_NAME", {
        value: { ...item, isCallAPI: true },
        _index: index,
        currentOrg: currentOrg.value.id,
      });
    });
  }
});

const handleAnswer = (answer: any) => {
  currentValue.value = answer;
  emits("update:answer", answer);
  emits("onUpdate", answer);
};

const openModalMoreInfor = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_MORE_INFO,
    properties: {
      isMoreInfoModal: true,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const checkAllValidations = async () => {
  let isAllValid = true,
    listDoamins = [] as any[];
  for (let index = 0; index < listDomainRef.value.length; index++) {
    const test = await listDomainRef.value[index].saveChanges();
    if (!test) {
      isAllValid = false;
    }
    listDoamins.push(test.finalValue);
  }
  return isAllValid;
};

defineExpose({
  checkAllValidations,
});
</script>

<style scoped>
.question-body {
  border: 1px solid var(--ui-rule, #eff0f1);
  background: var(--ui-white, #fff);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}
.description-body {
  line-height: normal;
}
::placeholder {
  color: #b7b7b7;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
}
.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  width: 98%;
  color: #211f58;
}
::-ms-input-placeholder {
  color: red;
}
@media screen and (max-width: 590px) {
  .enter__name {
    width: 100%;
  }
}
</style>
